import { Button, Dropdown, Menu, Space } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { t } from "i18next";
import ApiService from "../../core/service/ApiService";
import Helper from "../../core/Helper";
import { useEffect, useState } from "react";

export default function FormDownload({ appointmentId, unitId }) {
    const [pdf, setPdf] = useState('')
    const [unit, setUnit] = useState({
        unitForms: []
    })

    const onClick = async (item) => {
        if (item.key === 'pdf') {
            await downloadPdf()
        }
        else if (item.key === 'word') {
            await downloadWord()
        }
        else if (item.key === 'print') {
            await print()
        }
    }

    const downloadPdf = async (formId) => {
        const res = await ApiService.Appointment.GetOnamFormPdf(appointmentId, formId);

        if (res.success) {
            Helper.File.saveFile({
                blobLink: res.data,
                fileName: res.fileName
            })
        }
    }

    const downloadWord = async (formId) => {
        const res = await ApiService.Appointment.GetOnamFormWord(appointmentId, formId);

        if (res.success) {
            Helper.File.saveFile({
                blobLink: res.data,
                fileName: res.fileName
            })
        }
    }

    const print = async (e, formId) => {
        e.stopPropagation()
        const res = await ApiService.Appointment.GetOnamFormPdf(appointmentId, formId);
        if (res.success) {
            setPdf(res.data)
        }
    }

    const menu2 = (
        <Menu>
            {
                unit?.unitForms?.map(form => (
                    <Menu.Item key={form.id}>
                        {form.language}
                        <Space style={{ marginLeft: 8 }}>
                            <Button
                                size={'small'}
                                onClick={(e) => print(e, form.id)}>
                                {t('Print')}
                            </Button>
                            <Button
                                size={'small'}
                                onClick={() => downloadPdf(form.id)}>
                                {t('Pdf')}
                            </Button>
                            <Button
                                size={'small'}
                                onClick={() => downloadWord(form.id)}>
                                {t('Word')}
                            </Button>
                        </Space>
                    </Menu.Item>
                ))
            }
        </Menu>
    )

    const getUnit = async () => {
        if (unitId) {
            const res = await ApiService.Unit.GetUnit(unitId);
            if (res.success) {
                setUnit(res.data)
            }
        }
    }

    useEffect(() => {
        getUnit()
    }, [appointmentId, unitId]);

    return (
        <>
            <Dropdown size={'small'} overlay={menu2} placement="bottomRight">
                <Button size="small">
                    <DownOutlined />
                    {t('Onam Form')}
                </Button>
            </Dropdown>
            <iframe id={'print-pdf'} src={pdf} style={{ display: 'none' }} onLoad={(e) => {
                if (pdf) {
                    const frameWindow = e.target.contentWindow;
                    frameWindow.focus();
                    frameWindow.print();
                }
            }} />
        </>
    )
}